<template>
    <div class="tranjou-account-cell" :title="accountDescription">
        <account-link :account-no="accountNo" class="text-primary">
            {{ accountNo }}
        </account-link>
        &nbsp;-&nbsp;
        <span v-if="!transactionLine.subAccountUuid">
            {{ accountDescription }}
        </span>
        <sub-account-link v-else-if="transactionLine.subAccountUuid" :uuid="transactionLine.subAccountUuid" class="text-primary">
            <i class="inline-block -mb-[1px]" :class="subAccountIcon"/>
            {{ transactionLine.subAccountName }}
        </sub-account-link>
    </div>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'
import {CUSTOMER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'
import {findAccountByNo} from '@/bookkeeping-account/bookkeepingAccount.service'
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: {
                panelId: Number,
                panelPathSegment: String
            },
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params.data as TransactionLine
})

const accountNo = computed(() => transactionLine.value.accountNo)

const isCustomer = computed(() => accountNo.value === CUSTOMER_ACCOUNT_NO)

const accountDescription = computed(() => {
    if (!accountNo.value) return ''
    return findAccountByNo(accountNo.value)?.name
})

const subAccountIcon = computed(() => {
    if (!transactionLine.value.subAccountUuid) return ''
    return isCustomer.value ? 'i-ph-user' : 'i-ph-factory'
})

</script>

<style>
@reference "@/index.css";
@reference "tailwindcss";

.tranjou-account-cell {
    @apply truncate;
}

</style>